"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _default =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1i6yi0i0"
})("flex-grow:1;");

exports.default = _default;